<script setup lang="ts">
  import type { Segment } from "@utils/composables/useConditionsSentence";

  defineProps<{
    segments: Segment[];
    prefix?: string;
  }>();
</script>

<template>
  <span class="text-foreground-secondary">
    <span
      v-if="prefix"
      class="mr-1"
      >{{ prefix }}</span
    >
    <template
      v-for="(segment, index) in segments"
      :key="index">
      <span
        :class="{
          'font-semibold text-primary': segment.kind === 'q' || segment.kind === 'v',
          'text-destructive': segment.kind === 'empty',
        }"
        >{{ segment.text }}</span
      >
    </template>
  </span>
</template>
